export default __webpack_public_path__ + "assets/images/539149ac56c8f02e31137dbae2f83df5.jpg";